import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { gbp } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  const { wishlist, toggleWishlist } = useStore();
  const fav = wishlist.includes(product.id);
  const onSale = product.sale_price && product.sale_price < product.price;
  const soldOut = product.availability === "ready-to-ship" && (product.stock ?? 0) <= 0;

  return (
    <div className="group flex flex-col gap-3 ck-fade-up" style={{ animationDelay: `${(index % 4) * 80}ms` }} data-testid={`product-card-${product.id}`}>
      <div className="relative overflow-hidden rounded-sm bg-brand-blush/40 aspect-[3/4]">
        <Link to={`/product/${product.slug}`}>
          <img src={product.images?.[0]} alt={product.alt_text || product.title} loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </Link>
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {product.new_arrival && <span className="bg-white/90 text-brand-ink text-[10px] uppercase tracking-luxe px-2.5 py-1 rounded-sm">New</span>}
          {onSale && <span className="bg-brand-pink text-brand-ink text-[10px] uppercase tracking-luxe px-2.5 py-1 rounded-sm">Sale</span>}
          {product.availability === "made-to-order" && <span className="bg-white/90 text-brand-ink text-[10px] uppercase tracking-luxe px-2.5 py-1 rounded-sm">Made to order</span>}
          {soldOut && <span className="bg-brand-ink text-white text-[10px] uppercase tracking-luxe px-2.5 py-1 rounded-sm">Sold out</span>}
        </div>
        <button onClick={() => toggleWishlist(product.id)} aria-label="Add to wishlist"
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 flex items-center justify-center hover:bg-brand-pink transition-colors"
          data-testid={`wishlist-toggle-${product.id}`}>
          <Heart className={`w-4 h-4 ${fav ? "fill-brand-ink" : ""}`} />
        </button>
      </div>
      <div>
        <div className="flex items-start justify-between gap-2">
          <Link to={`/product/${product.slug}`} className="font-serif-display text-lg leading-tight hover:text-brand-pink transition-colors" data-testid={`product-title-${product.id}`}>{product.title}</Link>
        </div>
        <p className="text-[11px] uppercase tracking-luxe text-muted-foreground mt-0.5">{product.subcategory}</p>
        <div className="flex items-center gap-2 mt-1">
          {onSale
            ? <><span className="text-sm text-brand-pink font-medium">{gbp(product.sale_price)}</span><span className="text-sm text-muted-foreground line-through">{gbp(product.price)}</span></>
            : <span className="text-sm font-medium">{gbp(product.price)}</span>}
        </div>
        {product.colours?.length > 0 && (
          <div className="flex gap-1.5 mt-2">
            {product.colours.slice(0, 5).map((c) => (
              <span key={c.id} title={c.name} className="w-4 h-4 rounded-full border border-brand-border" style={{ background: c.swatch }} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
